import React from 'react';
import RatingStars from '../ui/RatingStars';
import { ClockIcon, CalendarIcon, TrashIcon, CheckCircleIcon } from '../common/IconsComponent';

const CartItem = ({ lesson, onToggleSelection, onRemove }) => {
  return (
    <div className={`relative bg-white rounded-xl overflow-hidden border transition-colors ${
      lesson.selected ? 'border-indigo-300' : 'border-gray-200'
    }`}>

      {/* Selected overlay */}
      {lesson.selected && (
        <div className="absolute inset-0 bg-indigo-500/10 border-2 border-indigo-400/30 rounded-xl pointer-events-none z-10" />
      )}

      {/* Remove button */}
      <button
        type="button"
        onClick={() => onRemove(lesson.id)}
        title="הסר מהסל"
        className="absolute top-2 left-2 z-20 w-6 h-6 flex items-center justify-center rounded-full bg-red-50 text-red-500 hover:bg-red-100 border border-red-100 transition-colors"
      >
        <TrashIcon size={13} />
      </button>

      <div className="flex min-w-0">

        {/* Thumbnail */}
        <div className="relative w-20 h-20 sm:w-28 sm:h-28 flex-shrink-0 bg-indigo-100 flex items-center justify-center">
          <span className="text-indigo-300 text-xs">תמונה</span>

          {/* Select toggle */}
          <button
            type="button"
            onClick={() => onToggleSelection(lesson.id)}
            title={lesson.selected ? 'בטל בחירה' : 'בחר לתשלום'}
            className={`absolute top-1.5 right-1.5 z-20 w-5 h-5 rounded-full flex items-center justify-center shadow-sm transition-colors ${
              lesson.selected
                ? 'bg-indigo-600 text-white'
                : 'bg-white border border-gray-300 text-gray-400 hover:bg-gray-50'
            }`}
          >
            <CheckCircleIcon size={11} />
          </button>
        </div>

        {/* Details */}
        <div className="flex-1 min-w-0 p-2 sm:p-3 flex flex-col justify-between h-20 sm:h-28">

          {/* Title */}
          <h3 className="text-xs sm:text-sm font-bold text-gray-900 truncate leading-snug">
            {lesson.title}
          </h3>

          {/* Instructor + rating */}
          <div className="flex items-center gap-2 sm:gap-4 text-xs text-gray-600 min-w-0">
            <span className="flex items-center gap-1 truncate">
              <span>👤</span>
              <span className="truncate">{lesson.instructor}</span>
            </span>
            <div className="flex-shrink-0" dir="ltr">
              <RatingStars value={lesson.rating} count={lesson.ratingCount} />
            </div>
          </div>

          {/* Date + time + price */}
          <div className="flex items-center gap-2 sm:gap-4 text-xs text-gray-600 min-w-0">
            <span className="flex items-center gap-1 flex-shrink-0">
              <CalendarIcon className="w-3 h-3" />
              <span>{lesson.date}</span>
            </span>
            <span className="flex items-center gap-1 flex-shrink-0">
              <ClockIcon className="w-3 h-3" />
              <span>{lesson.time}</span>
            </span>
            <span className="font-bold text-blue-800 mr-auto whitespace-nowrap">
              ₪{lesson.price}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CartItem;